export default "./icons/alpha.png";